// let host=process.env.VUE_APP_MYHOST
let host = window.settings.server.url
let api = window.settings.server.path.api
export const config = {
  host,
  apiUrl: host + api
}
